import * as types from "./mutation-types";
import CacheHelper from "@/cacheHelper";

const cache = new CacheHelper({
  key: "CACHE_KEY",
  ttl: 60 * 5, // 5 mins
});

/**
 * All VueX actions should go here.
 * They should check if data exists via the cache, and any api calls should be made to the /flat endpoint by default
 */
export const actions = {
  async setBanner({ commit }, {bannerId}) {
    let banner;

    try {
      banner = await this.dispatch("Banner/loadSlider", { bannerId, saveInState: false }, { root: true });
      commit(types.SET_BANNER, banner);
    } catch (err) {
      console.log("🚀 ~ file: actions.js ~ line 22 ~ setBanner ~ err", err);
    }
    return Promise.resolve(banner);
  },

  /**
   * Clear localStorage cache
   * * TODO: Should this be global?
   */
  async clearCache(context) {
    cache.removeItem(cacheConfig.key);
    return Promise.resolve(cacheConfig.key);
  },
};
